<div class="audit-log-page" data-tour="audit-logs-overview">
  <div class="audit-log-head" data-tour-ready="audit-logs-overview">
    <div>
      <h2>{{ 'AUDIT_LOGS.TITLE' | translate }}</h2>
      <p>{{ 'AUDIT_LOGS.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="audit-log-filters">
    <div class="filter-item filter-item-wide">
      <input nz-input [(ngModel)]="search" [placeholder]="'AUDIT_LOGS.FILTERS.SEARCH' | translate" (keyup.enter)="applyFilters()" />
    </div>
    <div class="filter-item filter-item-wide">
      <input nz-input [(ngModel)]="actor" [placeholder]="'AUDIT_LOGS.FILTERS.ACTOR' | translate" (keyup.enter)="applyFilters()" />
    </div>
    <div class="filter-item filter-item-log-kind">
      <nz-select [(ngModel)]="selectedLogKind" nzAllowClear [nzPlaceHolder]="'AUDIT_LOGS.FILTERS.LOG_KIND' | translate">
      <nz-option *ngFor="let option of logKindOptions" [nzValue]="option.value" [nzLabel]="option.labelKey | translate"></nz-option>
      </nz-select>
    </div>
    <div class="filter-item">
      <nz-select [(ngModel)]="selectedAction" nzAllowClear [nzPlaceHolder]="'AUDIT_LOGS.FILTERS.ACTION' | translate">
      <nz-option *ngFor="let option of actionOptions" [nzValue]="option.value" [nzLabel]="option.labelKey | translate"></nz-option>
      </nz-select>
    </div>
    <div class="filter-item">
      <nz-select [(ngModel)]="selectedResourceType" nzAllowClear [nzPlaceHolder]="'AUDIT_LOGS.FILTERS.RESOURCE_TYPE' | translate">
      <nz-option *ngFor="let option of resourceTypeOptions" [nzValue]="option.value" [nzLabel]="option.labelKey | translate"></nz-option>
      </nz-select>
    </div>
    <div class="filter-item filter-item-date-range">
      <nz-range-picker
      [(ngModel)]="dateRange"
      [nzPlaceHolder]="[
        ('AUDIT_LOGS.FILTERS.DATE_FROM' | translate),
        ('AUDIT_LOGS.FILTERS.DATE_TO' | translate)
      ]"
      ></nz-range-picker>
    </div>
    <div class="filter-actions">
      <button nz-button nzType="primary" (click)="applyFilters()">{{ 'AUDIT_LOGS.FILTERS.APPLY' | translate }}</button>
      <button nz-button (click)="resetFilters()">{{ 'AUDIT_LOGS.FILTERS.RESET' | translate }}</button>
    </div>
  </div>

  <nz-table [nzData]="logs" [nzLoading]="isLoading" [nzShowPagination]="false" [nzFrontPagination]="false" nzBordered>
    <thead>
      <tr>
        <th>{{ 'AUDIT_LOGS.TABLE.WHEN' | translate }}</th>
        <th>{{ 'AUDIT_LOGS.TABLE.WHO' | translate }}</th>
        <th>{{ 'AUDIT_LOGS.TABLE.TYPE' | translate }}</th>
        <th>{{ 'AUDIT_LOGS.TABLE.ACTION' | translate }}</th>
        <th>{{ 'AUDIT_LOGS.TABLE.RESOURCE' | translate }}</th>
        <th>{{ 'AUDIT_LOGS.TABLE.SUMMARY' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let log of logs" class="audit-row" (click)="openDetails(log)">
        <td>{{ formatTimestamp(log.occurredAt) }}</td>
        <td>{{ getActorLabel(log) }}</td>
        <td>
          <nz-tag [nzColor]="getLogKind(log) === 'audit' ? 'blue' : 'default'">
            {{ ('AUDIT_LOGS.KINDS.' + getLogKind(log)) | translate }}
          </nz-tag>
        </td>
        <td>{{ getActionLabel(log.action) }}</td>
        <td>
          <div class="resource-main">{{ getResourceLabel(log) }}</div>
          <div class="resource-type" *ngIf="getResourceTypeDisplayLabel(log)">{{ getResourceTypeDisplayLabel(log) }}</div>
        </td>
        <td>
          <ng-container *ngIf="getSummaryParts(log).length; else emptySummary">
            <div class="summary-part" *ngFor="let part of getSummaryParts(log)">{{ part }}</div>
          </ng-container>
          <ng-template #emptySummary>—</ng-template>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div class="empty-state" *ngIf="!isLoading && !logs.length">{{ 'AUDIT_LOGS.EMPTY' | translate }}</div>

  <nz-pagination
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    [nzTotal]="total"
    [nzPageSizeOptions]="[10, 20, 50]"
    [nzShowQuickJumper]="true"
    [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
    class="audit-pagination"
  ></nz-pagination>

  <nz-drawer [nzVisible]="isDrawerVisible" [nzWidth]="720" [nzTitle]="'AUDIT_LOGS.DETAIL.TITLE' | translate" (nzOnClose)="closeDrawer()">
    <ng-container *nzDrawerContent>
      <nz-spin [nzSpinning]="isDetailLoading">
        <ng-container *ngIf="selectedLog as log">
          <nz-descriptions nzBordered [nzColumn]="1" class="audit-descriptions">
            <nz-descriptions-item [nzTitle]="'AUDIT_LOGS.DETAIL.WHEN' | translate">{{ formatTimestamp(log.occurredAt) }}</nz-descriptions-item>
            <nz-descriptions-item [nzTitle]="'AUDIT_LOGS.DETAIL.WHO' | translate">{{ getActorLabel(log) }}</nz-descriptions-item>
            <nz-descriptions-item [nzTitle]="'AUDIT_LOGS.DETAIL.ACTION' | translate">{{ getActionLabel(log.action) }}</nz-descriptions-item>
            <nz-descriptions-item [nzTitle]="'AUDIT_LOGS.DETAIL.TYPE' | translate">
              <nz-tag [nzColor]="getLogKind(log) === 'audit' ? 'blue' : 'default'">
                {{ ('AUDIT_LOGS.KINDS.' + getLogKind(log)) | translate }}
              </nz-tag>
            </nz-descriptions-item>
            <nz-descriptions-item [nzTitle]="'AUDIT_LOGS.DETAIL.RESOURCE' | translate">
              {{ getResourceLabel(log) }}<ng-container *ngIf="getResourceTypeDisplayLabel(log)"> · {{ getResourceTypeDisplayLabel(log) }}</ng-container>
            </nz-descriptions-item>
          </nz-descriptions>

          <div class="detail-block" *ngIf="getLogKind(log) === 'audit' && getDiffEntries(log).length">
            <h3>{{ 'AUDIT_LOGS.DETAIL.CHANGES' | translate }}</h3>
            <div class="diff-list">
              <div class="diff-entry" *ngFor="let entry of getDiffEntries(log)">
                <div class="diff-entry-head">
                  <div class="diff-field">{{ fieldLabel(entry.field) }}</div>
                  <nz-tag nzColor="blue">{{ getChangeTypeLabel(entry.changeType) }}</nz-tag>
                </div>
                <div class="diff-values">
                  <div class="diff-value diff-value-before">
                    <div class="diff-value-label">{{ 'AUDIT_LOGS.DETAIL.OLD_VALUE' | translate }}</div>
                    <div class="diff-value-body">
                      <ng-container *ngIf="getContactPersonAuditCards(entry.before, entry.field) as contactPersonCards; else beforeDiffValue">
                        <div class="contact-person-audit-list">
                          <article class="contact-person-audit-card" *ngFor="let contactPerson of contactPersonCards">
                            <div class="contact-person-audit-card__heading">{{ contactPerson.heading }}</div>
                            <div class="contact-person-audit-card__row" *ngFor="let row of contactPerson.rows">
                              <span class="contact-person-audit-card__label">{{ row.label }}</span>
                              <span class="contact-person-audit-card__value">{{ row.value }}</span>
                            </div>
                          </article>
                        </div>
                      </ng-container>
                      <ng-template #beforeDiffValue>
                        {{ formatDiffValue(entry.before, entry.field, log) }}
                      </ng-template>
                    </div>
                  </div>

                  <div class="diff-value diff-value-after">
                    <div class="diff-value-label">{{ 'AUDIT_LOGS.DETAIL.NEW_VALUE' | translate }}</div>
                    <div class="diff-value-body">
                      <ng-container *ngIf="getContactPersonAuditCards(entry.after, entry.field) as contactPersonCards; else afterDiffValue">
                        <div class="contact-person-audit-list">
                          <article class="contact-person-audit-card" *ngFor="let contactPerson of contactPersonCards">
                            <div class="contact-person-audit-card__heading">{{ contactPerson.heading }}</div>
                            <div class="contact-person-audit-card__row" *ngFor="let row of contactPerson.rows">
                              <span class="contact-person-audit-card__label">{{ row.label }}</span>
                              <span class="contact-person-audit-card__value">{{ row.value }}</span>
                            </div>
                          </article>
                        </div>
                      </ng-container>
                      <ng-template #afterDiffValue>
                        {{ formatDiffValue(entry.after, entry.field, log) }}
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-block" *ngIf="getPropertyServiceChangeGroups(log).length">
            <h3>{{ 'AUDIT_LOGS.DETAIL.SERVICE_CHANGES' | translate }}</h3>
            <div class="document-change-list">
              <div class="document-change-entry" *ngFor="let group of getPropertyServiceChangeGroups(log)">
                <div class="document-change-title">{{ group.serviceType }}</div>
                <div class="document-change-row" *ngIf="group.addedServices.length">
                  <span class="document-change-label">{{ 'AUDIT_LOGS.SERVICES.ADDED' | translate }}</span>
                  <span>{{ group.addedServices.join(', ') }}</span>
                </div>
                <div class="document-change-row" *ngIf="group.removedServices.length">
                  <span class="document-change-label">{{ 'AUDIT_LOGS.SERVICES.REMOVED' | translate }}</span>
                  <span>{{ group.removedServices.join(', ') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-block" *ngIf="getDocumentChangeItems(log).length">
            <h3>{{ 'AUDIT_LOGS.DETAIL.DOCUMENT_CHANGES' | translate }}</h3>
            <div class="document-change-list">
              <div class="document-change-entry" *ngFor="let item of getDocumentChangeItems(log)">
                <div class="document-change-title">{{ item.sectionTitle }}</div>
                <div class="document-change-row" *ngIf="item.sectionAdded">
                  {{ 'AUDIT_LOGS.DOCUMENT.SECTION_ADDED' | translate }}
                </div>
                <div class="document-change-row" *ngIf="item.sectionRemoved">
                  {{ 'AUDIT_LOGS.DOCUMENT.SECTION_REMOVED' | translate }}
                </div>
                <div class="document-change-row" *ngIf="item.addedFiles.length">
                  <span class="document-change-label">{{ 'AUDIT_LOGS.DOCUMENT.FILES_ADDED' | translate }}</span>
                  <span>{{ item.addedFiles.join(', ') }}</span>
                </div>
                <div class="document-change-row" *ngIf="item.removedFiles.length">
                  <span class="document-change-label">{{ 'AUDIT_LOGS.DOCUMENT.FILES_REMOVED' | translate }}</span>
                  <span>{{ item.removedFiles.join(', ') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-block" *ngIf="getLogKind(log) === 'activity'">
            <h3>{{ 'AUDIT_LOGS.DETAIL.ACTIVITY' | translate }}</h3>
            <p class="activity-summary">{{ getActivitySummary(log) }}</p>
          </div>

          <div class="detail-block" *ngIf="getDetailSummaryParts(log).length && getLogKind(log) !== 'activity'">
            <h3>{{ 'AUDIT_LOGS.DETAIL.SUMMARY' | translate }}</h3>
            <div class="summary-list">
              <div class="summary-part" *ngFor="let part of getDetailSummaryParts(log)">{{ part }}</div>
            </div>
          </div>

          <div class="detail-block" *ngIf="getBulkDetailItems(log).length">
            <h3>{{ getBulkTitle(log) }}</h3>
            <div class="summary-list">
              <div class="summary-part" *ngFor="let item of getBulkDetailItems(log)">
                <strong>{{ item.label }}</strong> {{ item.value }}
              </div>
            </div>
          </div>
        </ng-container>
      </nz-spin>
    </ng-container>
  </nz-drawer>
</div>
